export default{
  setAllNews: (state, payload) => {state.allNews = payload},
  setNews: (state, payload) => {state.news = payload},
}